import React, { useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import LabelComponent from "pages/profile/common/label";
import { ReactComponent as EditIcon } from "images/profile/edit-icon.svg";
import { ReactComponent as AddCircleIcon } from "images/auth/add-circle.svg";

function PreferredCurrencyInformation({
  onEditClick = () => {},
  isShowEditIcon = false,
}) {
  const [t] = useTranslation();
  const [isHover, setIsHover] = useState(false);
  const userDetails = useSelector((state) => state.userDetails || {});
  const code = userDetails?.currency?.code;

  const isShowAddIcon = !code;

  const user = useSelector((state) => state.user || {});
  const isLoggedInByMagicLink = user?.isAdmin ?? false;

  return (
    <div
      id="preferredCurrencySection"
      className={`flex p-[24px] flex-col gap-[12px] self-stretch cursor-pointer ${
        isHover && !isShowAddIcon && !isLoggedInByMagicLink
          ? "bg-[#F3F5F7]"
          : ""
      }`}
      onMouseEnter={() => {
        if (!isLoggedInByMagicLink) {
          setIsHover(true);
        }
      }}
      onMouseLeave={() => setIsHover(false)}
    >
      <div className="flex justify-between items-center self-stretch">
        <div className="text-[#1D1B22] font-semibold text-[24px]">
          {t("preferredCurrency")}
        </div>
        {isShowEditIcon && !isShowAddIcon && !isLoggedInByMagicLink && (
          <EditIcon
            className={`cursor-pointer ${isHover ? "visible" : "invisible"}`}
            onClick={() => {
              if (!isLoggedInByMagicLink) {
                onEditClick();
              }
            }}
          />
        )}
      </div>

      {isShowAddIcon && !isLoggedInByMagicLink && (
        <div
          className="flex gap-[8px] cursor-pointer max-w-[175px]"
          onClick={() => {
            if (!isLoggedInByMagicLink) {
              onEditClick();
            }
          }}
        >
          <AddCircleIcon />
          <div className="text-primary font-bold text-[16px] not-italic">
            {t("addCurrency")}
          </div>
        </div>
      )}

      {!isShowAddIcon && (
        <div className="flex flex-wrap gap-[20px]">
          <LabelComponent title={t("preferredCurrency")} subTitle={`${code}`} />
        </div>
      )}
    </div>
  );
}

PreferredCurrencyInformation.propTypes = {
  onEditClick: PropTypes.func,
  isShowEditIcon: PropTypes.bool,
};

export default PreferredCurrencyInformation;
